// Import the clipboard library
import ClipboardJS from "clipboard";
const copyButton = document.getElementById("ccw-copy-to-keyboard");
const letter = document.getElementById("ccw-complain-interface-letter");
const downloadButton = document.getElementById("ccw-download-letter");
if (letter) {
  ccwCopyToClipboard();
  downloadButton.addEventListener("click", function () {
    // Convert the HTML template to RTF
    const rtf = ccwHtmlToRTF(letter);
    // Download the RTF file
    ccwDownloadRTFFile("ccw-letter.rtf", rtf);
  });
}
function ccwCopyToClipboard() {
  const clipboard = new ClipboardJS(copyButton, {
    text: function () {
      const cloneContent = letter.cloneNode(true);
      const paragraphs = cloneContent.querySelectorAll("p");
      let text = "";
      paragraphs.forEach(function (paragraph) {
        if (
          !paragraph.classList.contains(
            "ccw-complain-interface__remove-line-if-empty--hide"
          )
        ) {
          const marks = paragraph.querySelectorAll("mark");

          marks.forEach(function (mark) {
            const html = mark.innerHTML;
            const text = html.replace(/<br\s*\/?>/g, "\n");
            mark.textContent = text;
          });
          const trimmedText = paragraph.textContent.trim();
          if (trimmedText) {
            text += trimmedText + "\n";
          }
        }
      });

      return text;
    },
  });

  // Display a success message
  clipboard.on("success", function (event) {
    event.clearSelection();
    const copySuccess = document.getElementById("ccw-copy-success");
    copySuccess.classList.add("ccw-complain-interface__copy-success--show");
    setTimeout(function () {
      copySuccess.classList.remove(
        "ccw-complain-interface__copy-success--show"
      );
    }, 3000);
  });

  // Display an error message
  clipboard.on("error", function (event) {
    const copyError = document.getElementById("ccw-copy-error");
    copyError.classList.add("ccw-complain-interface__copy-error--show");
    setTimeout(function () {
      copyError.classList.remove("ccw-complain-interface__copy-error--show");
    }, 3000);
  });
}

// Create a function to escape special characters in RTF
function ccwEscapeRTF(str) {
  return str.replace(/\\/g, "\\\\").replace(/{/g, "\\{").replace(/}/g, "\\}");
}

// Create a function to convert HTML to RTF
function ccwHtmlToRTF(html) {
  let rtf = "";

  // Add the RTF header
  rtf +=
    "{\\rtf1\\ansi\\ansicpg1252\\deff0\\nouicompat\\deflang1033\\deflangfe1033{\\fonttbl{\\f0\\fnil\\fcharset0 Arial;}}\n";
  rtf += "{\\*\\generator Riched20 10.0.19041}\\viewkind4\\uc1 \n";
  rtf += "\\pard\\sb200\\sa200\\sl300\\slmult1\\f0\\fs22\\lang9 ";

  for (let node of html.children) {
    if (node.textContent !== "") {
      if (node.nodeName === "P") {
        const classNames = node.className.split(" ");
        if (
          classNames &&
          !classNames.includes(
            "ccw-complain-interface__remove-line-if-empty--hide"
          )
        ) {
          if (classNames.includes("ccw-complain-interface__text-right")) {
            rtf += "{\\pard\\qr ";
          } else {
            rtf += "{\\pard ";
          }
          for (let child of node.childNodes) {
            if (child instanceof Text) {
              rtf += ccwEscapeRTF(child.textContent);
            }
            if (child.nodeName === "MARK") {
              for (let markChild of child.childNodes) {
                if (markChild instanceof Text) {
                  rtf += ccwEscapeRTF(markChild.textContent);
                }
                if (markChild.nodeName === "BR") {
                  rtf += "\\line\n";
                }
              }
            }
            if (child.nodeName === "BR") {
              rtf += "\\line\n";
            }
          }
          rtf += "\\par}\n";
          rtf += "\\line\n";
        }
      }
    }
  }

  rtf += "}";

  return rtf;
}

// Create a function to download a file from the browser
function ccwDownloadRTFFile(filename, content) {
  let blob = new Blob([content], { type: "application/rtf" });
  let url = URL.createObjectURL(blob);
  let link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
